module.exports = __webpack_public_path__ + "img/icon7.8fd97fd2.png";